export default __webpack_public_path__ + "static/step1-f181ee8a39db590db6c5e5b0d746ec4d.svg";